import {
  FaReact,
  FaNodeJs,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaWordpress,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiExpress,
  SiSupabase,
  SiFlutter,
  SiReact,
} from "react-icons/si";

export default function About() {
  const stack = [
    { name: "HTML", icon: <FaHtml5 /> },
    { name: "CSS", icon: <FaCss3Alt /> },
    { name: "JavaScript", icon: <FaJs /> },
    { name: "React", icon: <FaReact /> },
    { name: "Tailwind", icon: <SiTailwindcss /> },
    { name: "Node.js", icon: <FaNodeJs /> },
    { name: "Express", icon: <SiExpress /> },
    { name: "Supabase", icon: <SiSupabase /> },
    { name: "Flutter", icon: <SiFlutter /> },
    { name: "React Native", icon: <SiReact /> },
    { name: "WordPress", icon: <FaWordpress /> },
  ];

  return (
    <section className="py-12 sm:py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto text-center">
        
        {/* Heading */}
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold mb-2">
          About Us
        </h2>

        <p className="text-xs sm:text-sm text-gray-500 mb-8 max-w-xl mx-auto">
          At MegaMind Business Solutions, we build modern websites and mobile apps using
          the latest technologies to help your business grow.
        </p>

        {/* Tech Stack */}
        <h3 className="text-sm sm:text-lg font-semibold mb-4">
          Technologies We Use
        </h3>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
          {stack.map((tech, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center p-3 rounded-xl bg-gray-50 hover:shadow-md transition"
            >
              <div className="text-xl sm:text-2xl mb-1">
                {tech.icon}
              </div>
              <p className="text-[10px] sm:text-xs text-gray-600">
                {tech.name}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}